import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/common.css'

Vue.config.productionTip = false
import Viewer from 'v-viewer' // 引入js
import 'viewerjs/dist/viewer.css' // 引入css
Vue.use(Viewer)
// 引入antd
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);


import store from './store'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
